import { Link } from "react-router-dom";
import { siteIntro } from "@/mocks/site";
import { getHotVideos } from "@/lib/videos";

export default function SiteIntro() {
  const hot = getHotVideos(3);

  return (
    <section className="px-4 md:px-8 lg:px-12">
      <div className="rounded-lg bg-background-100 border border-background-200/70 overflow-hidden">
        <div className="grid grid-cols-1 lg:grid-cols-12">
          <div className="lg:col-span-7 p-6 md:p-10">
            <div className="flex items-center gap-2.5">
              <span className="h-[2px] w-6 bg-primary-500" />
              <span className="text-[11px] tracking-[0.24em] text-accent-400 font-label uppercase">
                About Passion Video
              </span>
            </div>
            <h2 className="mt-3 font-heading text-3xl md:text-4xl font-bold text-foreground-50 leading-tight">
              精选而非海量，
              <br className="hidden sm:block" />
              把时间留给真正想看的内容
            </h2>
            <p className="mt-4 text-sm md:text-[15px] leading-relaxed text-foreground-400 max-w-2xl">
              {siteIntro.summary}
            </p>

            <div className="mt-7 grid grid-cols-1 sm:grid-cols-2 gap-4">
              {siteIntro.points.map((point) => (
                <div key={point.title} className="flex items-start gap-3">
                  <span className="w-9 h-9 rounded-md bg-secondary-800/70 text-accent-400 flex items-center justify-center shrink-0">
                    <i className={`${point.icon} text-lg`} />
                  </span>
                  <div>
                    <h3 className="text-sm font-medium text-foreground-100">{point.title}</h3>
                    <p className="mt-1 text-xs leading-relaxed text-foreground-500">{point.description}</p>
                  </div>
                </div>
              ))}
            </div>

            <Link
              to="/about"
              className="inline-flex items-center gap-2 mt-7 h-10 px-5 rounded-md border border-background-300/70 text-sm text-foreground-200 hover:border-primary-400 hover:text-foreground-50 transition-colors whitespace-nowrap cursor-pointer"
            >
              了解平台更多
              <i className="ri-arrow-right-line" />
            </Link>
          </div>

          <div className="lg:col-span-5 bg-background-200/50 p-6 md:p-8 border-t lg:border-t-0 lg:border-l border-background-300/40">
            <div className="flex items-center justify-between">
              <h3 className="text-sm font-medium text-foreground-100">本周热度榜</h3>
              <span className="text-[11px] text-foreground-600 font-label tracking-wider">TOP 3</span>
            </div>
            <ul className="mt-4 space-y-3">
              {hot.map((video, index) => (
                <li key={video.id}>
                  <Link to={`/detail/${video.id}`} className="flex items-center gap-3 group cursor-pointer">
                    <span className="font-heading text-2xl font-bold text-primary-400/80 w-7 shrink-0">
                      {index + 1}
                    </span>
                    <span className="w-12 h-16 rounded-md overflow-hidden shrink-0 bg-background-300">
                      <img
                        src={video.cover}
                        alt={`${video.title} 封面`}
                        title={`${video.title} 热门推荐`}
                        className="w-full h-full object-cover object-top"
                      />
                    </span>
                    <span className="min-w-0 flex-1">
                      <span className="block text-sm text-foreground-100 truncate group-hover:text-accent-400 transition-colors">
                        {video.title}
                      </span>
                      <span className="block mt-1 text-[11px] text-foreground-500 truncate">
                        {video.category} · {video.region} · {(video.views / 10000).toFixed(1)}万播放
                      </span>
                    </span>
                    <i className="ri-arrow-right-s-line text-foreground-600 group-hover:text-accent-400 transition-colors" />
                  </Link>
                </li>
              ))}
            </ul>

            <div className="mt-6 pt-5 border-t border-background-300/40 grid grid-cols-2 gap-4">
              <div>
                <p className="font-heading text-2xl font-bold text-foreground-50">30+</p>
                <p className="text-[11px] text-foreground-500 mt-0.5">精选作品</p>
              </div>
              <div>
                <p className="font-heading text-2xl font-bold text-foreground-50">13</p>
                <p className="text-[11px] text-foreground-500 mt-0.5">覆盖地区</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}